import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';


@Component({
    selector: 'app-autotransporte',
    templateUrl: './autotransporte.component.html',
    styleUrls: ['./autotransporte.component.scss']
})
export class AutotransporteComponent implements OnInit {
    @Input() idOperacion: any;
    @Input() idATransporte: any;
    @Output() FormTransporteEventEmiter = new EventEmitter<any>();


    catPermSCT: any[] = [];
    catConfigVehicular: any[] = [];

    anioPattern = /^[1-9]\d{3}$/;

    autotransportes: any[] = [];
    FormTransporte = new FormGroup({
        idATransporte: new FormControl(0),
        nombre: new FormControl(null),
        PermSCT: new FormControl(null, [Validators.required]),
        NumPermisoSCT: new FormControl(null, [Validators.required]),
        ConfigVehicular: new FormControl(null, [Validators.required]),
        PlacaVM: new FormControl(null, [Validators.required]),
        AnioModeloVM: new FormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.min(4), Validators.pattern(this.anioPattern)]),
        AseguraRespCivil: new FormControl(null, [Validators.required]),
        PolizaRespCivil: new FormControl(null, [Validators.required]),
        AseguraMedAmbiente: new FormControl(null),
        PolizaMedAmbiente: new FormControl(null),
        AseguraCarga: new FormControl(null),
        PolizaCarga: new FormControl(null),
        PrimaSeguro: new FormControl(null),
        idOperacion: new FormControl(0),
    });

    constructor(
        private _snackBar: MatSnackBar,
        private store: Store<AppState>,
        private srvcoal: CoalService
    ) { }

    ngOnInit(): void {
        this.getCatPermSCT();
        this.getCatConfigVehicular();
        this.senddata();
    }

    get f() { return this.FormTransporte.controls; }

    asign(value) {

        /*
        this.idATransporte = value.idTransporte;
        this.FormTransporte.controls.nombre.setValue(value.nombre);
        this.FormTransporte.controls.PermSCT.setValue(value.PermSCT);
        this.FormTransporte.controls.NumPermisoSCT.setValue(value.NumPermisoSCT);
        this.FormTransporte.controls.ConfigVehicular.setValue(value.ConfigVehicular);
        this.FormTransporte.controls.PlacaVM.setValue(value.PlacaVM);
        this.FormTransporte.controls.AnioModeloVM.setValue(value.AnioModeloVM);
        this.FormTransporte.controls.AseguraRespCivil.setValue(value.AseguraRespCivil);
        this.FormTransporte.controls.PolizaRespCivil.setValue(value.PolizaRespCivil);
        this.FormTransporte.controls.AseguraMedAmbiente.setValue(value.AseguraMedAmbiente);
        this.FormTransporte.controls.PolizaMedAmbiente.setValue(value.PolizaMedAmbiente);
        this.FormTransporte.controls.AseguraCarga.setValue(value.AseguraCarga);
        this.FormTransporte.controls.PolizaCarga.setValue(value.PolizaCarga);
        this.FormTransporte.controls.PrimaSeguro.setValue(value.PrimaSeguro);
        */
    }

    saveOrUpdateTransporte() {

        if (this.FormTransporte.valid) {
            this.FormTransporte.value.idOperacion = this.idOperacion;
            let parametros = {
                ...this.FormTransporte.value
            }

            // parametros.PermSCT          = this.FormTransporte.controls.PermSCT.value.clave;
            // parametros.ConfigVehicular  = this.FormTransporte.controls.ConfigVehicular.value.clave;

        }
    }

    deleteTransporte() {

    }

    getCatPermSCT() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService('cat-perm-scts?populate=*&pagination[start]=0&pagination[limit]=300').subscribe(
            (res: any) => {
                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {
                    this.catPermSCT = res?.data || [];
                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

    getCatConfigVehicular() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService('cat-config-vehiculares?populate=*&pagination[start]=0&pagination[limit]=300').subscribe(
            (res: any) => {
                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {
                    this.catConfigVehicular = res?.data || [];
                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

    senddata() {
        this.FormTransporte.statusChanges.subscribe(status => {
            if (this.FormTransporte.valid) {
                this.FormTransporteEventEmiter.emit(this.idATransporte);
            }
        });
    }

}
